export default "__VITE_ASSET__DI35pcJM__"